import { DataProvider, IErrorModel, useMutation } from "@nf/common";

export const useCancelSubscriptionSwitch = () => {
  return useMutation<void, IErrorModel, void>(() =>
    DataProvider.cancelSubscriptionSwitch()
  );
};
